import React from "react";
import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";

const Footer = () => {
  const scrollToSection = (e, path) => {
    // If it's a hash link (starts with #)
    if (path.startsWith('#')) {
      e.preventDefault();
      const element = document.querySelector(path);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };
  const location = useLocation();

  const smallPaddingPages = [
    "/ContactUs",
    "/AboutSection",
    "/Services",
    "/RealtorServices",
    "/PrivacyPolicy",
    "/FAQ",
    "/404",

  ];

  const paddingTopClass = smallPaddingPages.includes(location.pathname)
    ? "pt-20"
    : "pt-48";

  return (
    <footer className={`bg-black text-white font-poppins ${paddingTopClass} w-full`}>
      <div className="w-full">
        {/* Top Section */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12 lg:py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-8 xl:gap-12">
            {/* Logo and Subscription */}
            <div className="lg:col-span-2 space-y-6 md:pr-4">
              <div className="flex flex-col items-start">
                <button 
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  className="cursor-pointer bg-transparent border-none p-0"
                >
                  <img
                    src="assets/images/logo-footer.png"
                    alt="BluePeak Realty"
                    className="w-56 sm:w-64 -ml-2 sm:-ml-3 -mt-2 mb-4"
                  />
                </button>
                <p className="text-white/80 text-sm sm:text-[15px] leading-relaxed max-w-md">
                  We are your personal real estate navigator, guiding you to your
                  dream property with expert advice.
                </p>
              </div>

              {/* Subscription Form */}
              <form 
                onSubmit={(e) => {
                  e.preventDefault();
                  const emailInput = e.target.elements.email;
                  const email = emailInput.value.trim();
                  if (email) {
                    window.location.href = `mailto:bluepeakrealty99@gmail.com?subject=Newsletter Subscription&body=Please subscribe me to the BluePeak Realty newsletter. My email is: ${encodeURIComponent(email)}`;
                  }
                }} 
                className="w-full max-w-md"
              >
                <div className="flex flex-col sm:flex-row gap-3 w-full">
                  <input
                    name="email"
                    type="email"
                    placeholder="Enter email id"
                    required
                    className="flex-grow px-4 sm:px-5 py-3 bg-transparent border border-white/30 rounded-full text-white placeholder-white/60 text-sm sm:text-[15px] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                  <button
                    type="submit"
                    className="bg-[#041C77] hover:bg-[#0a2b8a] px-6 sm:px-6 py-3 rounded-full text-white font-medium text-sm sm:text-[15px] whitespace-nowrap transition-colors duration-200 w-full sm:w-auto text-center"
                  >
                    Subscribe
                  </button>
                </div>
              </form>
            </div>

            {/* Links */}
            <div className="mt-2 lg:mt-0">
              <h4 className="text-white font-medium text-base sm:text-[17px] mb-4 sm:mb-6">Links</h4>
              <ul className="space-y-3 sm:space-y-4 text-sm sm:text-[15px] text-white/80">
                <li>
                  <a 
                    href="#home" 
                    onClick={(e) => scrollToSection(e, '#home')}
                    className="hover:text-white hover:underline transition-colors inline-block py-1 cursor-pointer"
                  >
                    Home
                  </a>
                </li>
                <li>
                  <a 
                    href="#about" 
                    onClick={(e) => scrollToSection(e, '#about')}
                    className="hover:text-white hover:underline transition-colors inline-block py-1 cursor-pointer"
                  >
                    About Us
                  </a>
                </li>
                <li>
                  <a 
                    href="#services" 
                    onClick={(e) => scrollToSection(e, '#services')}
                    className="hover:text-white hover:underline transition-colors inline-block py-1 cursor-pointer"
                  >
                    Services
                  </a>
                </li>
                <li>
                  <a 
                    href="#why-us" 
                    onClick={(e) => scrollToSection(e, '#why-us')}
                    className="hover:text-white hover:underline transition-colors inline-block py-1 cursor-pointer"
                  >
                    Why Us
                  </a>
                </li>
              </ul>
            </div>

            {/* Information */}
            <div className="mt-2 lg:mt-0">
              <h4 className="text-white font-medium text-base sm:text-[17px] mb-4 sm:mb-6">Information</h4>
              <ul className="space-y-3 sm:space-y-4 text-sm sm:text-[15px] text-white/80">
                <li>
                  <Link 
                    to="#contact" 
                    onClick={(e) => {
                      e.preventDefault();
                      const element = document.getElementById('contact');
                      if (element) {
                        element.scrollIntoView({ behavior: 'smooth' });
                      }
                    }}
                    className="hover:text-white hover:underline transition-colors inline-block py-1 cursor-pointer"
                  >
                    Contact us
                  </Link>
                </li>
                {/* <li><Link to="/PrivacyPolicy" className="hover:text-white hover:underline transition-colors inline-block py-1">Privacy Policy</Link></li>
                <li><Link to="/FAQ" className="hover:text-white hover:underline transition-colors inline-block py-1">FAQ</Link></li>
                <li><Link to="/404" className="hover:text-white hover:underline transition-colors inline-block py-1">404</Link></li> */}
              </ul>
            </div>

            {/* Contact */}
            <div className="mt-2 lg:mt-0">
              <h4 className="text-white font-medium text-base sm:text-[17px] mb-4 sm:mb-6">Contact</h4>
              <ul className="space-y-3 sm:space-y-4 text-sm sm:text-[15px] text-white/80">
                <li className="flex items-start">
                  <a href="tel:+917016937139" className="hover:text-white transition-colors">+91 7016937139</a>
                </li>
                <li className="hover:text-white transition-colors">
                  <a href="mailto:bluepeakrealty99@gmail.com" className="hover:underline">bluepeakrealty99@gmail.com</a>
                </li>
                <li className="pt-2">
                  <div className="flex flex-wrap gap-3 sm:gap-4">
                    <a 
                      href="https://www.instagram.com/bluepeak.realty/" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="inline-flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 border border-white/30 rounded-full hover:bg-white hover:text-pink-600 transition-colors duration-200" 
                      aria-label="Instagram"
                    >
                      <FaInstagram className="w-4 h-4" />
                    </a>
                    <a 
                      href="https://www.facebook.com/bluepeakrealty1" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="inline-flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 border border-white/30 rounded-full hover:bg-white hover:text-blue-600 transition-colors duration-200" 
                      aria-label="Facebook"
                    >
                      <FaFacebookF className="w-4 h-4" />
                    </a>
                    <a 
                      href="https://www.youtube.com/@BluepeakRealty" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="inline-flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 border border-white/30 rounded-full hover:bg-white hover:text-red-600 transition-colors duration-200" 
                      aria-label="YouTube"
                    >
                      <FaYoutube className="w-5 h-5" />
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="w-full bg-[#212121]">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 text-center text-xs sm:text-sm text-white/70">
            <p>© 2025 Design by shirpp solutions. All rights reserved. BluePeak Realty</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
